export default {
  // 数据统计
  totalData: "共计{count}条数据",

  // 加载
  loading: "拼命加载中",

  // 表格列
  operation: "操作",
  client: "客户端",
  state: "状态",
  updateTime: "更新时间",
  paymentMethod: "收款方式",
  paymentDetail: "收款详情",
  bankCard: "银行卡号/账号",
  bankBranch: "银行支行",
  bankName: "银行名称",

  // 空状态
  noPaymentData: "当前调证文件中未解析到收款方式记录数据",

  // 下载
  downloadDetails: "下载数据明细",
  downloadFileName: "数据明细",
};
